import React, { useEffect, useState } from 'react';
import MenuItemImageRepository from '../../app/User/MenuItem/Image/MenuItemImageRepository';
const defaultThumbnailImage = "/storage/menu_item_images/default.png"

export default function MenuItemThumbnailImage({menuItem, allowUseMerchantImage, forceUseMerchantImage}) {
    const [imageUrl, setImageUrl] = useState(defaultThumbnailImage)
    const [menuItemImageId, setMenuItemImageId] = useState('')

    useEffect(() => {
        let imageUrl = (forceUseMerchantImage && menuItem.getImageUrl()) ||   // Use MerchantImage if exist, ignore UserImage
            (allowUseMerchantImage && !menuItem.thumbnail_image_url && menuItem.getImageUrl()) ||  // Use MerchantImage if exist, only when UserImage not exists
            menuItem.thumbnail_image_url || window.default_thumbnail_image || defaultThumbnailImage
        setImageUrl(imageUrl)

        let callbackKey = `MenuItemThumbnailImage_${menuItem.id}_` + Math.random()
        MenuItemImageRepository.getInstance().loadImage(menuItem, (menuItemImagesList) => {
            if (menuItemImagesList.length) {
                menuItemImagesList.sort((a, b) => a.sort - b.sort)
                setImageUrl(menuItemImagesList[0].getImageUrl())
                setMenuItemImageId(menuItemImagesList[0].id)
            }
        }, callbackKey)

        return () => {
            MenuItemImageRepository.getInstance().removeCallback(callbackKey)
        }
    }, [menuItem])
    

    if (imageUrl) {
        return <img data-id={menuItemImageId} className="user-thumbnail" src={imageUrl} />
    }
    return <span style={{display: "inline-block", width: "50px", height:"50px", backgroundColor: "green"}}></span>
}